import {NgModule} from "@angular/core";
import {DialogService} from "../bootstrap-modal/dialog.service";
import {BrowserModule} from "@angular/platform-browser";
import {FormsModule} from "@angular/forms";
import {BootstrapModalModule} from "../bootstrap-modal/bootstrap-modal.module";
import {SimpleHelpDialogComponent} from "./simple-help-dialog.component";
import {HelpDialogButtonComponent} from "./help-dialog-button.component";

@NgModule({
  providers: [
    DialogService,
  ],
  imports: [
    BrowserModule,
    FormsModule,
    BootstrapModalModule,
  ],
  declarations: [
    SimpleHelpDialogComponent,
    HelpDialogButtonComponent,
  ],
  exports: [
    HelpDialogButtonComponent,
  ],
  entryComponents: [
    SimpleHelpDialogComponent,
  ],
})
export class HelpDialogModule {}
